import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useConfig } from '../../contexts/ConfigContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { isConfigured } = useConfig();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isConfigured) {
        navigate('/config');
      } else if (!isAuthenticated) {
        navigate('/login');
      }
    }
  }, [isAuthenticated, isConfigured, loading, navigate]);

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body1" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!isConfigured || !isAuthenticated) {
    return null; // Navigation will handle redirect
  }

  return children;
};

export default ProtectedRoute;
